import { Component, Prop, h } from '@stencil/core';
import { serviceNumber as fallbackServiceNumber } from '../../utils/ttarp';

@Component({
  tag: 'customer-contact',
  styleUrl: 'customer-contact.scss',
})
export class CustomerContact {
  @Prop() serviceNumber: string;

  render() {
    const serviceNumber = this.serviceNumber ?? fallbackServiceNumber;

    return (
      <div class="ghf-customerContact--default">
        <div>
          <a class="img ciHeader-phoneNumberLink" title="Customer Support Headset" href={`tel:${serviceNumber}`} />
          <span class="ghf-customerContact-helpText">Help</span>
        </div>
        <div>
          <span class="ghf-customerContact-text">Talk to a Real Person</span>
          <a class="ghf-customerContact-storeText ciHeader-phoneNumberLink" href={`tel:${serviceNumber}`}>
            {serviceNumber}
          </a>
        </div>
      </div>
    );
  }
}
